<template>
  <div
    id="group-of-accreditation-body-tabs"
    :data-qa="dataQa">
    <sTabs
      v-model="tab"
      background-color="main__green"
      class="supplier-tabs tabs"
      color="var(--black-color)"
      :data-qa="dataQa + '-tabs'">
      <template #actions>
        <div class="spacer"/>
        <template v-if="tab == 'documents'">
          <ImportDialog
            :apply="addNewFiles"
            :create-file-handler="createFileHandler"
            external-delete
            file_size="5"
            :files.sync="newFiles"
            files-types
            new-endpoints
            :preview="false"
            subtitle=" "
            :title="$t('Tenders.ToAddDocs')"
            @close="closeImportDialog"
            @deleteFile="deleteFile">
            <template #activator="{ open }">
              <div>
                <TooltipedBtn
                  data-qa="btn-add-new-file"
                  icon="add-file"
                  small-btn
                  :text="$t('Tenders.ToAddDocs')"
                  :texted="$vuetify.breakpoint.lgAndUp"
                  @click="open"/>
              </div>
            </template>
          </ImportDialog>
        </template>
      </template>
      <sTabPanel
        key="offers"
        data-qa="item-tab-offers"
        name="offers">
        <template #label>
          <sBadge
            color="transparent"
            :content="tabCount.offers"
            data-qa="tab-offers"
            offset-x="4"
            offset-y="10"
            overlap
            :text-color="'var(--black-color)'">
            {{ tabs.offers }}
          </sBadge>
        </template>
        <EmptyBlock
          v-if="!item || !item.requests || !item.requests.length"
          custom-class="mt-0 pa-10"
          :data-qa="dataQa + '-offers-noData'"
          :text="$t('Tenders.NoData')"/>
        <GroupOfAccreditationItemRequests
          v-else
          :accreditation-group-id="item.id"
          :data-qa="dataQa + '-requests-list'"
          :items.sync="item.requests"
          @downloadArhive="downloadArhive"/>
      </sTabPanel>
      <sTabPanel
        key="categories"
        data-qa="item-tab-categories"
        name="categories">
        <template #label>
          <sBadge
            color="transparent"
            :content="tabCount.categories"
            data-qa="tab-categories"
            offset-x="4"
            offset-y="10"
            overlap
            :text-color="'var(--black-color)'">
            {{ tabs.categories }}
          </sBadge>
        </template>
        <EmptyBlock
          v-if="!item || !item.categories || !item.categories.length"
          custom-class="mt-0 pa-10"
          :data-qa="dataQa + '-categories-noData'"
          :text="$t('Tenders.NoData')"/>
        <div
          v-else
          class="text-left"
          :data-qa="dataQa + '-categories-list'">
          <div
            v-for="(classificationCode, classificationCodeIndex) in item.categories"
            :key="classificationCode+'_'+classificationCodeIndex"
            class="secondary__green_chosen mb-1"
            :data-qa="dataQa + '-category-item-' + classificationCodeIndex"
            style="padding: 16px 24px">
            {{ classificationCode.classificationCode }} {{ classificationCode.title }}
          </div>
        </div>
      </sTabPanel>
      <sTabPanel
        key="documents"
        data-qa="item-tab-documents"
        :label="tabs.documents"
        name="documents">
        <EmptyBlock
          v-if="!item || !files.length"
          custom-class="mt-0 pa-10"
          :data-qa="dataQa + '-documents-noData'"
          :text="$t('Tenders.NoData')"/>
        <DocumentList
          v-else
          :attachments="files"
          can_delete
          :data-qa="dataQa + '-documents-list'"
          :new-endpoints="true"
          small
          @deleteFile="deleteFile"/>
      </sTabPanel>
      <sTabPanel
        key="requirements"
        data-qa="item-tab-requirements"
        :disabled="!$can('show', 'useAccreditationDocumentRequirements')"
        name="requirements">
        <template #label>
          <sBadge
            color="transparent"
            :content="tabCount.requirements"
            data-qa="tab-requirements"
            offset-x="4"
            offset-y="10"
            overlap
            :text-color="'var(--black-color)'">
            {{ tabs.requirements }}
          </sBadge>
        </template>
        <EmptyBlock
          v-if="!item || !item.requirements || !item.requirements.length"
          custom-class="mt-0 pa-10"
          :data-qa="dataQa + '-requirements-noData'"
          :text="$t('Tenders.NoData')"/>
        <GroupOfAccreditationRequirements
          :loading="loading"
          :requirements="item.requirements"/>
      </sTabPanel>
    </sTabs>
  </div>
</template>
<script>
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import DocumentList from 'components/common/blocks/DocumentList.vue'
import ImportDialog from 'components/common/dialogs/ImportDialog.vue'
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import GroupOfAccreditationItemRequests from 'components/group of accreditations/GroupOfAccreditationItemRequests.vue'
import GroupOfAccreditationRequirements from 'components/group of accreditations/create_edit/GroupOfAccreditationRequirements.vue'

import { StorageFile } from '@/types/commonFile.js'

import functionRandom from 'mixins/functionRandom'
import functionNormalizes from 'mixins/functionNormalizes'

export default {
  name: 'GroupOfAccreditationItemBody',
  mixins: [functionRandom, functionNormalizes],
  data() {
    return {
      tab: 'offers',
      newFiles: [],
      files: [],
      tabs: {
        offers: this.$t('Tenders.Offers'),
        categories: this.$t('Tenders.Categories'),
        documents: this.$t('Tenders.Documents'),
        requirements: this.$t('groupOfAccreditation.requirements'),
      }
    }
  },
  methods: {
    getFilesForArhive(files, maxLength = 50) {
      const existingFiles = []
      return (files || []).map(file => {
        let fileName = file.title || file.fileName || file.uri?.split('/').pop() || 'file'
        fileName = this.$_normalizeFileName(fileName, existingFiles, maxLength)
        existingFiles.push(fileName)

        return {
          Type: 'file',
          FileUrl: `${window.config.GrapgQlUrl}/document/${file.fileId || file.id}?fileName=${fileName}`,
          FolderName: null,
          FolderItems: null
        }
      })
    },
    formatTimestamp(historyItem) {
      const d = new Date(historyItem.statusChangeDate || historyItem.statusDate)
      const p = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}${p(d.getHours())}${p(d.getMinutes())}`
    },
    formatHistoryFolderName(historyItem) {
      return `${this.formatTimestamp(historyItem)}-${historyItem.status}`
    },
    // Кнопка status-group-chips: вложенная структура, содержимое в корне архива (без обёрток организатора/участника)
    requirementAllDocuments(inputObject) {
      const dirs = []
      const dir = (name, items) => {
        const FolderName = this.$_normalizeDirectoryName(name, dirs)
        dirs.push(FolderName)
        return { Type: 'folder', FolderName, FileUrl: null, FolderItems: items }
      }
      const items = [
        ...this.getFilesForArhive(inputObject.files),
        ...(inputObject.requirements || []).map(r => dir(r.name, this.getFilesForArhive(r.files))),
        ...(inputObject.history || []).map(h => dir(this.formatHistoryFolderName(h), this.getFilesForArhive(h.files))),
      ]
      return { items }
    },
    // Кнопка documents-header: плоский архив, все файлы в корне
    requirementDocuments(inputObject) {
      return { items: this.getFilesForArhive(inputObject.files, 125) }
    },
    // Кнопка history-item: плоский архив файлов одной записи истории, все в корне
    requirementHistoryItemDocuments(inputObject, historyItem) {
      return { items: historyItem ? this.getFilesForArhive(historyItem.files, 125) : [] }
    },
    downloadArhive(inputObject, arhiveType, objectProps) {
      const participant = inputObject?.supplier?.title || 'archive'
      const arhiveBuilders = {
        requirementAllDocuments: { build: () => this.requirementAllDocuments(inputObject), name: () => participant },
        requirementDocuments: { build: () => this.requirementDocuments(inputObject), name: () => participant },
        requirementHistoryItemDocuments: {
          build: () => this.requirementHistoryItemDocuments(inputObject, objectProps?.sub),
          name: () => `${participant}-${this.formatTimestamp(objectProps.sub)}-${objectProps.sub.status}`,
        },
      }
      const builder = arhiveBuilders[arhiveType]
      if (!builder) { return }

      const taskId = `${this.$_createGuid()}:${this.$store.getters['GET_USER'].login}`
      // Сырое (читабельное) имя — нормализация в имя файла происходит в DownloadFiles.finishDownload
      this.$notifier.generateFilesArhive(taskId, builder.build(), builder.name())
    },
    tabByValue(value) {
      return this.tabs[value] || {}
    },
    closeImportDialog() {
      this.newFiles = []
      if (!this.files?.length) {
        return
      }
      this.files.map(file => {
        if (file.deleted) {
          file.deleted = false
          file.error = false
        }
      })
    },
    bigFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    createFileHandler(file) {
      return new StorageFile(this.item.id, file, 'Accreditation')
    },
    async addNewFiles() {
      let addPromises = this.newFiles.map(async (file) => {
        return await file.uploadFile()
          .then(res => {
            if (res) {
              file.key = res
              file.fileId = res
              file.dateModified = new Date().toISOString()
              file.uri = `${window.config.GrapgQlUrl}/document/${res}`
              this.$emit('addedNewFile', file)
            } else {
              file.error = true
            }
          })
          .catch(() => {
            file.error = true
          })
      })
      await Promise.allSettled(addPromises)

      this.files = [...this.files, ...this.newFiles.filter(file => file.fileId)]
      this.updateItemFiles(this.files)
      this.newFiles = []
    },
    updateItemFiles(files) {
      const result = {...this.item}
      result.files = files
      this.$emit('update:item', result)
    },
    deleteFile(props) {
      if (!props.file.fileId) {
        this.newFiles.splice(props.n, 1)
        return
      }
      const result = this.$_.cloneDeep(this.files)?.filter(i => i.fileId !== props.file.fileId)
      this.files = result
      this.updateItemFiles(this.files)
    },
  },
  computed: {
    tabCount() {
      return {
        offers: this.item?.requests?.length || 0,
        categories: this.item?.categories?.length || 0,
        documents: this.item?.files?.length || 0,
        requirements: this.item?.requirements?.length || 0,
      }
    },
  },
  watch: {
    'item.files': {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.files = newValue ? newValue.map(i => {
          i.entityId = this.item.id
          return new StorageFile(this.item.id, i, 'Accreditation')
        }) : []
      }
    }
  },
  components: {
    EmptyBlock,
    DocumentList,
    ImportDialog,
    TooltipedBtn,
    GroupOfAccreditationItemRequests,
    GroupOfAccreditationRequirements,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
    },
    dataQa: {
      type: String,
      default: 'group-of-accreditation-item-body'
    },
  },
}
</script>
